export const RANGE_PRICES = {
  pluss: [47825, 55425, 79400],
  fager: [58175, 66462, 98412],
  trapes: [63300, 72187, 110225],
  areal: [49950, 56950, 82400],
  system: [55737, 63062, 98037],
  format: [52725, 60775, 87387],
  toniton: [60694, 69675, 103262],
  // systemSort: [71400, 82412, 122525],
  parallel: [48775, 56037, 81200],
  kvadrat: [38737, 45225, 63087],
  kube: [74250, 85150, 129700],
  designAkse: [69652, 80262, 121887],
  aspektKlassiskHvit: [44675, 51687, 73575],
  hisoyGrep: [36061, 41546, 52829],
  notteroy: [28820, 33967, 43409],
  stjernoya: [41911, 52387, 66604],
  tromoy: [38964, 45014, 56923],
  haoya: [38995, 45045, 56954],
  asmaloyKlassiskHvit: [33564, 39134, 50754],
}

export const WORKTOP_PRICES = {
  laminateBasic: [5423, 8093, 11372],
  laminate: [4768, 7239, 10620],
  solidTimber: [17871, 25599, 34602],
  granite: [12582, 18130, 25870],
}
